// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2Xn89","rootCenter":"LoadMoreObserver_rootCenter__3h5IP","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3Q5B8"};